import type { FunnelPopup, Popup } from './types';

/**
 * Fetching the exact same Contentful entry from the funnel via graphql gives back a different data structure than in Gatsby. Gatsby's structure is used directly by the exit popup component because it's a bit simpler and feels more natural. This function maps the funnel response to match that.
 */
export const mapContentToPopup = (funnelPopups: FunnelPopup[]): Popup[] =>
  funnelPopups
    .map((funnelPopup) => {
      switch (funnelPopup.__typename) {
        case 'ComponentExitPopupCarousel':
          return {
            ...funnelPopup,
            __typename: 'ContentfulComponentExitPopupCarousel' as const,
            id: funnelPopup.sys.id,
            slides: funnelPopup.slidesCollection.items.map((item) => ({
              ...item,
              image: { ...item.image, mimeType: item.image.contentType },
            })),
          };
      }
    })
    .filter((popup) => !!popup);
